import { createAsyncThunk } from "@reduxjs/toolkit";

import api from "../../../utils/api";
import { RootState } from "../../rootReducer";

// Busqueda de instalaciones asignadas a la plantilla
export const findAssignedLocations = createAsyncThunk(
  "formsubmitted/findAssignedLocations",
  async ({ formId }: { formId: string | undefined }, { rejectWithValue, getState }) => {
    const state = getState() as RootState;
    const locationList = state.formSubmittedSlice.locationList;

    try {
      const token = localStorage.getItem("token");
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-Type", "application/json");

      const result = await fetch(
        `${api.baseURL}formsubmitted/locations?form=${formId}&limit=10000`,
        {
          method: "GET",
          headers: headers,
        }
      );
      const data = await result.json();
      const selected: any = [];
      data.forEach((element: any) => {
        locationList.forEach((location: any) => {
          if (element.location.id === location.id) {
            selected.push(location);
          }
        });
      });
      return { assigned: data, selected: selected };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
